import { TextInput } from '@rbilabs/components-library/build/components/text-input';
import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { ActionsheetWrapper } from 'components/action-sheet';
import { primitive } from 'styles/constants/primitives';

export const Container = styled.div<{ $keyboardHeight?: number }>`
  column-gap: 1rem;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-block-end: ${props => `${props.$keyboardHeight}px`};
`;
export const StyledInput = styled(TextInput)`
  margin: 0.5rem 0;
  ${Styles.mobileSmall} {
    flex-basis: calc(12ch + 2rem);
    flex-shrink: 0;
  }
`;

export const StyleButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
`;

export const StyledButton = styled(ActionButton)<{
  isV2?: boolean;
  isWhiteBGFlagOn?: boolean;
  width: string;
}>`
  background-color: ${props => {
    if (props.isV2) {
      return Styles.color.primary;
    } else if (props.isWhiteBGFlagOn) {
      return props.theme.primaryBackground;
    } else {
      return Styles.color.white;
    }
  }};
  border: 1px solid ${Styles.color.primary};
  color: ${props => (props.isV2 ? primitive.$white : Styles.color.primary)};
  margin: 0.5rem 0;
  padding-inline: 1rem;
  width: ${props => props.width};

  &:disabled {
    background-color: ${props => (props.isV2 ? primitive.$blackOpacity10 : Styles.color.white)};
    border: initial;
    color: ${props => (props.isV2 ? primitive.$disabledText : Styles.color.grey.five)};
  }
  &:hover {
    color: ${Styles.color.white};
    background-color: ${props => props.isV2 && Styles.color.primaryHover};
  }
`;
export const StyledActionSheet = styled(ActionsheetWrapper)`
  padding: 0;
`;
